import React from "react";
import '../styles/Portfolio.css';

function Portfolio(props) {
    return (
        <div className="col-sm-6 col-md-4">
            <div className="card offset">
                <a href={props.url} target="_blank" rel="noopener noreferrer">
                    <img src={props.image} alt={props.title} className="card-img image" />
                    <div className="middle">
                        <strong className="text">{props.title}</strong>
                        <p className="text"> {props.category}</p>
                        <span className="text-light">{props.technologies}</span>
                    </div>
                </a>
            </div>
            <div className="m-2">
            <a href={props.github} target="_blank" rel="noopener noreferrer"><button className="btn btn-sm btn-info btn-block m-0">Github Repo</button></a>
            </div>
        </div>
    )
};

export default Portfolio;